/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

$(function () {
  $('.js-Env-wrap').hide()
  $('.holiday').show()
  $('.js-Env-btn').click(function () {
    $('.js-Env-btn').removeClass('current')
    $(this).addClass('current')
    $('.js-Env-wrap').hide()
    let href = $(this).attr('href')
    $('.' + href).show()
    return false
  })
})

$(function () {
  var position = $('.topInterviewTabWrap').offset().top
  $('.topInterviewItem').hide()
  $('.js-interview-1').show()
  $('.js-interview-btn').click(function () {
    $('.js-interview-btn').removeClass('current')
    $('.topInterviewItem').hide()
    let href = $(this).attr('href')
    $('.' + href).show()

    $('html,body').animate(
      {
        scrollTop: position,
      },
      {
        queue: false,
      }
    )
    return false
  })
  $('.js-interview-btn-1').click(function () {
    $('.js-interview-btn-1').addClass('current')
  })
  $('.js-interview-btn-2').click(function () {
    $('.js-interview-btn-2').addClass('current')
  })
  $('.js-interview-btn-3').click(function () {
    $('.js-interview-btn-3').addClass('current')
  })
})

$(function () {
  let position = $(window).scrollTop()
  if (position > 0) {
    $('.header').addClass('color')
  }
  $('.gNavBtn__box').click(function () {
    $('.header').toggleClass('white')
  })
  $(window).scroll(function () {
    let scroll = $(window).scrollTop()
    if (scroll > 0) {
      $('.header').addClass('color')
      $('.header').removeClass('white')
    } else {
      $('.header').removeClass('color')
    }
  })
})

//  #####  ##  ##      #####            ##   ##  ##
//  ##     ##  ##      ##               ##   ##  ##
//  #####  ##  ##      #####  ########  ##   ##  ##
//  ##     ##  ##      ##               ##   ##  ##
//  ##     ##  ######  #####             #####   ##
/*
<label class="customFile flex vcenter">
    <input class="js-customFile customFile__input" data-target="doc" type="file" name="添付資料" />
    <div class="customFile__btn flex vcenter hcenter" for="file">
        ファイル選択
    </div>
    <div class="js-customFile-out--doc customFile__text">
        5MB以内のPDFファイルをアップロードしてください。
    </div>
</label>
<input id="js-customFile-name--doc" type="hidden" name="file_name" value="">
*/
// ファイルアップロードUIのカスタム
const customFileUpload = document.getElementsByClassName('js-customFile')
const customFileNameTrace = document.getElementsByClassName('js-customFile-trace')
if (customFileUpload[0]) {
  window.addEventListener('change', function (e) {
    fileUpSet(e.target)
  })
  window.addEventListener('click', function (e) {
    fileUpDel(e.target)
  })
  setTimeout(() => {
    for (const item of customFileNameTrace) {
      fileNameTrace(item)
    }
  }, 1000)
}

function fileUpSet(item) {
  if (!item.classList.contains('js-customFile')) {
    return
  }

  const file = item.files[0] // ファイルを取得
  const target = item.dataset.target // 各種反映先のスラッグ

  const fileSizeLimit = 5 // サイズ上限（MB）
  const sizeUnit = file.size > 1024 * 1024 ? 'MB' : 'KB' // 単位をMBかKBに分岐
  const fileSizeUnit = sizeUnit === 'MB' ? file.size / (1024 * 1024) : file.size / 1024 // 単位に合わせて補正したファイルサイズ
  const fileSizeView = fileSizeUnit.toFixed(2) + sizeUnit // ファイルサイズ出力テキスト

  // 表示するテキスト
  let fileText = file.name + ' (' + fileSizeView + ')'
  // エラー判定
  let isError = false

  // サイズバリデーション
  if (file.size > fileSizeLimit * (1024 * 1024)) {
    isError = true
    item.value = '' // 入力を削除
    fileText = `<span style="color:red">ファイルサイズは${fileSizeLimit}MB以下にしてください (${fileSizeView})。</span>`
  }
  // 拡張子バリデーション　実際の中身ではなく、ファイル名だけを見る簡単なもの
  if (!checkExt(file.name, ['pdf'])) {
    isError = true
    item.value = '' // 入力を削除
    fileText = '<span style="color:red">PDFファイルのみがアップロードできます。</span>'
  }

  // ファイル名やエラーを表示させる
  const fileTextTarget = document.getElementsByClassName('js-customFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileText
  }

  // ファイル名を送信させる
  const fineNameTarget = document.getElementById('js-customFile-name--' + target)
  if (fineNameTarget) {
    if (!isError) {
      fineNameTarget.value = file.name
    } else {
      fineNameTarget.value = ''
    }
  }

  // 切り替わる要素を反映させる
  const fineDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fineDelTarget[0]) {
    if (!isError) {
      for (const iterator of fineDelTarget) {
        iterator.classList.add('active')
      }
    } else {
      for (const iterator of fineDelTarget) {
        iterator.classList.remove('active')
      }
    }
  }

  // 文字列から拡張子を返す
  function getExt(fileName) {
    const pos = fileName.lastIndexOf('.')
    if (pos === -1) return ''
    return fileName.slice(pos + 1)
  }
  // 拡張子を検証する
  function checkExt(fileName, exts) {
    // 比較のため小文字にする
    const ext = getExt(fileName).toLowerCase()
    // 許可する拡張子の一覧extsから対象の拡張子があるか確認する
    if (exts.indexOf(ext) === -1) {
      return false
    }
    return true
  }
}
function fileUpDel(item) {
  if (!item.classList.contains('js-customFile-del')) {
    return
  }

  const target = item.dataset.target // 各種反映先のスラッグ

  // ファイルを消す
  document.getElementById('js-customFile--' + target).value = ''

  // 送信するファイル名を消す
  const fineNameTarget = document.getElementById('js-customFile-name--' + target)
  if (fineNameTarget) {
    fineNameTarget.value = ''
  }

  // 切り替わる要素を消す
  const fineDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fineDelTarget[0]) {
    for (const iterator of fineDelTarget) {
      iterator.classList.remove('active')
    }
  }

  // テキスト表示欄をリセットする
  const fileTextTarget = document.getElementsByClassName('js-customFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileTextTarget[index].dataset.def
  }
}

// ブラウザバックで戻ってきたときのファイル名を補完する
function fileNameTrace(item) {
  if (item.value === '') {
    return
  }
  const target = item.dataset.target // 各種反映先のスラッグ

  // ファイル名を反映させる
  const fileTextTarget = document.getElementsByClassName('js-customFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = item.value
  }

  // 切り替わる要素を出す
  const fineDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fineDelTarget[0]) {
    for (const iterator of fineDelTarget) {
      iterator.classList.add('active')
    }
  }
}
